/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosRequestConfig } from 'axios';
import { getHttpClient } from './HttpClient';

const httpClient = getHttpClient();
export const axiosBaseQuery = (): BaseQueryFn<{
  url: string
  method: AxiosRequestConfig['method']
  data?: AxiosRequestConfig['data']
  params?: AxiosRequestConfig['params'],
  headers?: AxiosRequestConfig['headers'],
},
  unknown,
  { message: string, name: string }> =>
  async ({ url, method, data, params, headers }) => {
    const result = await httpClient.request({ url, method, data, params, headers })
    return { data: result.data }
  }
